import React, { useState, useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import classNames from 'classnames'
import { useSelector } from 'react-redux'

import CheckoutPlans from '../views/CheckoutPlans'
import ConnectionError from '../views/ConnectionError'
import Dashboard from '../views/Dashboard'
import EmailRecover from '../views/EmailRecover'
import ForgotPassword from '../views/ForgotPassword'
import { HomepagePsic } from '../views/Homepage/Psic'
import { HomepagePsiq } from '../views/Homepage/Psiq'
import Login from '../views/Login'
import NpsResponse from '../views/NpsResponse'
import Payment from '../views/Payment'
import PlanResponse from '../views/Payment/Sections/PlanResponse'
import ProfessionalProfile from '../views/ProfessionalProfile'
import ResendPin from '../views/ResendPin'
import ResetPassword from '../views/ResetPassword'
import Survey from '../views/Survey'
import CustomError from 'views/CustomError'
import FaceId from 'views/FaceId/FaceId'
import GroupPlanSelection from 'views/Register/Steps/GroupPlanSelection'
import PhoneCheck from 'views/Register/Steps/PhoneCheck'
import FeedbackSuccess from 'views/Register/Steps/FeedbackSuccess'
import AttachMedicalRequest from 'views/Register/Steps/AttachMedicalRequest'
import InfoGroup from 'views/Register/Steps/InfoGroup'
import InfoPersonal from 'views/Register/Steps/InfoPersonal'
import { CheckoutCreditCardSuccess } from 'views/Payment/Sections/CheckoutCreditCardSuccess'
import { NpsSchedule } from 'views/NpsSchedule'
import { NpsReviewCompleted } from 'views/NpsReviewCompleted'
import { NpsNegativeReview } from 'views/NpsNegativeReview'
import { RegisterMedicalRequest } from 'views/RegisterMedicalRequest'

import { AWAITING_MEDICAL_REQUEST } from 'settings/_personSettings'
import * as routes from '../settings/_routesSettings'
import * as permissions from '../settings/_permissionSettings'
import AuthPermissionRoute from './AuthPermissionRoute'
import CheckoutPlansRoute from './CheckoutPlansRoute'
import PaymentPrivateRoute from './PaymentPrivateRoute'
import PrivateRoute from './PrivateRoute'

export const history = createBrowserHistory()

const isBackgroundGradient = (currentUrl) => {
  return (
    currentUrl.includes('/psicologia-online/') ||
    currentUrl.includes('/psiquiatria-online/') ||
    currentUrl === routes.NPS_SCHEDULE_PAGE
  )
}

const isBackgroundGrey = (currentUrl) => {
  return (
    currentUrl === routes.DASHBOARD_HOME ||
    currentUrl === routes.DASHBOARD_HOME_PATIENT ||
    currentUrl === routes.DASHBOARD_GENERAL_VIEW ||
    currentUrl === routes.DASHBOARD_GRAPHICS_PROFESSIONAL ||
    currentUrl === routes.DASHBOARD_APPOINTMENTS ||
    currentUrl === routes.DASHBOARD_PATIENT_SETTINGS ||
    currentUrl === routes.DASHBOARD_PATIENT_PLANS ||
    currentUrl === routes.DASHBOARD_PATIENT_MEDICAL_EVALUATION)
}

export const AppRouter = () => {
  const userStatus = useSelector(state => state.auth?.profileSelected?.status_code)
  const [ isGrey, setGrey ] = useState(isBackgroundGrey(window.location.pathname))
  const [isGradient, setGradient] = useState(isBackgroundGradient(window.location.pathname))
  const usesNewMedicalRequestScreen = useSelector(state =>  state.auth?.planSelected?.uses_new_medical_request_screen)


  // Verifica se o usuário está "Aguardando Pedido Médico"
  useEffect(() => {
    if(![routes.REGISTER_ATTACH_MEDICAL_REQUEST, routes.REGISTER_MEDICAL_REQUEST, routes.REGISTER_SUCCESS_ATTACH_MEDICAL_REQUEST].includes(history.location.pathname) &&
      userStatus === AWAITING_MEDICAL_REQUEST) {
      if (usesNewMedicalRequestScreen) {
        history.push(routes.REGISTER_MEDICAL_REQUEST)
      } else {
        history.push(routes.REGISTER_ATTACH_MEDICAL_REQUEST)
      }

    }
  }, [userStatus])

  useEffect(() => {
    const unListenHistory = history.listen(location => {
      setGrey(isBackgroundGrey(location.pathname))
      setGradient(isBackgroundGradient(location.pathname))
    })

    return () => {
      unListenHistory()
    }

  }, [])

  return (
    <div className={classNames(
      'app', {
        'app--gradient': isGradient,
        'app--grey': isGrey,
      }
    )}>
      <Switch>
        <AuthPermissionRoute
          exact
          path={routes.APP}
          component={HomepagePsic}
          permission={permissions.USER_VIEW_HOMEPAGE}
        />
        <AuthPermissionRoute
          exact
          path={routes.HOME_PSIC}
          component={HomepagePsic}
          permission={permissions.USER_VIEW_HOMEPAGE}
        />
        <AuthPermissionRoute
          exact
          path={routes.HOME_PSIQ}
          component={HomepagePsiq}
          permission={permissions.USER_VIEW_HOMEPAGE}
        />
        <PrivateRoute exact path={routes.SURVEY_RESPONSE} component={NpsResponse} />

        <PrivateRoute exact path={routes.NPS_SCHEDULE_PAGE} component={NpsSchedule} />
        <PrivateRoute exact path={routes.NPS_REVIEW_COMPLETED_PAGE} component={NpsReviewCompleted} />
        <PrivateRoute exact path={routes.NPS_NEGATIVE_REVIEW} component={NpsNegativeReview} />

        <PrivateRoute
          exact
          path={routes.QUESTIONNAIRE()}
          component={Survey}
          permission={permissions.USER_VIEW_QUESTIONNAIRE}
        />
        <AuthPermissionRoute
          exact
          path={routes.PROFESSIONAL_PSIC_PROFILE()}
          component={ProfessionalProfile}
          permission={permissions.USER_VIEW_PROFESSIONAL_PROFILE}
        />
        <AuthPermissionRoute
          exact
          path={routes.PROFESSIONAL_PSIQ_PROFILE()}
          component={ProfessionalProfile}
          permission={permissions.USER_VIEW_PROFESSIONAL_PROFILE}
        />
        <PrivateRoute path={routes.DASHBOARD} component={Dashboard} />
        <PaymentPrivateRoute path={routes.PAYMENT} component={Payment} />

        {/* TEMPORARY FIRST CHECKOUT PLANS */}
        <CheckoutPlansRoute path={routes.CHECKOUT_PLANS} component={CheckoutPlans} />

        <Route exact path={routes.ERROR_CONECTION} component={ConnectionError} />
        <Route exact path={routes.LOGIN} component={Login} />

        <Route exact path={routes.REGISTER} component={GroupPlanSelection} />
        <Route exact path={routes.REGISTER_INFO_GROUP} component={InfoGroup} />
        <Route exact path={routes.REGISTER_INFO_PERSONAL} component={InfoPersonal} />
        <Route exact path={[routes.REGISTER_PHONE_CHECK, routes.REGISTER_PHONE_CHECK_PIN]} component={PhoneCheck} />
        <Route exact path={routes.REGISTER_SUCCESS} component={FeedbackSuccess} />


        <PrivateRoute
          exact
          hasHeader={false}
          path={[routes.REGISTER_ATTACH_MEDICAL_REQUEST, routes.REGISTER_SUCCESS_ATTACH_MEDICAL_REQUEST, routes.REGISTER_ATTACH_MEDICAL_REQUEST_DONE]}
          component={AttachMedicalRequest}
        />
        <PrivateRoute exact  hasHeader={false} path={routes.REGISTER_MEDICAL_REQUEST} component={RegisterMedicalRequest} />

        <Route exact path={routes.FORGOT_PASSWORD} component={ForgotPassword} />
        <Route exact path={routes.RESET_PASSWORD} component={ResetPassword} />
        <Route exact path={routes.RECOVER_EMAIL} component={EmailRecover} />
        <Route exact path={routes.RESEND_PIN} component={ResendPin} />
        <Route exact path={routes.PLAN_CHECKOUT} component={PlanResponse} />
        <Route exact path={routes.FACE_ID} component={FaceId} />

        <Route exact path={routes.CHECKOUT_CREDIT_CARD_SUCCESS_RESPONSE} component={CheckoutCreditCardSuccess} />

        <Route exact path="/test-error" render={() => {
          return <div foo={userStatus.does.not.exist}></div>
        }} />

        <Route>
          <CustomError
            title="Página não encontrada!"
            subtitle="A página não existe mais ou você pode ter digitado o endereço errado."
          />
        </Route>
      </Switch>
    </div>
  )
}

export default AppRouter
